import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  I18n,
  Link,
  Switch,
  Status,
  DataBlocks,
} from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

class NotificationPointPreview extends PureComponent {
  isPointDisabled() {
    const {
      isConfirmed,
      isEnabled,
      isRecoveryPassword,
    } = this.props;

    return !isConfirmed || isRecoveryPassword && isEnabled;
  }

  render() {
    const {
      type,
      isConfirmed,
      startEditing,
      pointValue,
      isEnabled,
      isToggling,
      togglePoint,
      showConfirmationPopup,
      children,
      isEditDisabled,
    } = this.props;

    return (
      <DataBlocks.TableRow
        className={cx('tableRow')}
      >
        <DataBlocks.TableCell className={cx('tableCell')}>
          <Switch
            className={cx('switch')}
            name={type}
            checked={isEnabled}
            isLoading={isToggling}
            disabled={this.isPointDisabled()}
            onChange={togglePoint}
          >
            <I18n path={`settings.points.${type}.title`} />
          </Switch>
        </DataBlocks.TableCell>
        <DataBlocks.TableCell className={cx('hiddenCell')}>
          {children}
        </DataBlocks.TableCell>
        <DataBlocks.TableCell
          className={cx('tableCell', 'value')}
          title={pointValue}
        >
          {pointValue}
        </DataBlocks.TableCell>
        <DataBlocks.TableCell className={cx('tableCell')}>
          <Link
            className={isEditDisabled && cx('disabled')}
            onClick={startEditing}
          >
            <I18n path={`common.${pointValue ? 'edit' : 'add'}`} />
          </Link>
        </DataBlocks.TableCell>
        <DataBlocks.TableCell className={cx('statusCell')}>
          {isConfirmed ? (
            <Status
              className={['success', 'compact', cx('status')]}
            >
              <I18n path="settings.notifications.confirmed" />
            </Status>
          ) : pointValue && (
            <Status
              className={['compact', cx('status')]}
            >
              <Link
                className={cx('notConfirmed')}
                onClick={showConfirmationPopup}
              >
                <I18n path="settings.notifications.notConfirmed" />
              </Link>
            </Status>
          )}
        </DataBlocks.TableCell>
      </DataBlocks.TableRow>
    );
  }
}

NotificationPointPreview.propTypes = {
  pointValue: PropTypes.string,
  type: PropTypes.string,
  isConfirmed: PropTypes.bool,
  isEnabled: PropTypes.bool,
  isToggling: PropTypes.bool,
  isRecoveryPassword: PropTypes.bool,
  isEditDisabled: PropTypes.bool,
  children: PropTypes.any,
  startEditing: PropTypes.func,
  togglePoint: PropTypes.func,
  showConfirmationPopup: PropTypes.func,
};

export default NotificationPointPreview;
